export const messages = {
  en: {
    itemReleaseUndo: {
      page: {
        title: 'Release Pending Orders',
        subtitle: 'Handle pending release orders',
        empty: 'No pending orders found'
      },
      title: 'Release Pending Orders',
      back: 'Back',
      refresh: 'Refresh',
      orderNo: 'Order No',
      releaseType: 'Release Type',
      applyUnit: 'Applicant Unit',
      applicant: 'Applicant',
      idCard: 'ID Card',
      phone: 'Phone',
      passTime: 'Pass Time',
      items: 'Items',
      viewItems: 'View Items',
      status: 'Status',
      plateNo: 'Plate No',
      none: 'None',
      operations: 'Operations',
      process: 'Process',
      detail: 'Detail'
    },

  },
  zh: {
    itemReleaseUndo: {
      page: {
        title: '放行待办单',
        subtitle: '处理待办放行单',
        empty: '暂无待办单数据'
      },
      title: '放行待办单',
      back: '返回',
      refresh: '刷新',
      orderNo: '单号',
      releaseType: '放行类型',
      applyUnit: '申请单位',
      applicant: '申请人',
      idCard: '身份证',
      phone: '手机号',
      passTime: '通行时间',
      items: '物品',
      viewItems: '查看物品',
      status: '状态',
      plateNo: '车牌号',
      none: '无',
      operations: '操作',
      process: '办理',
      detail: '详情'
    },

  }
}